import { setupLayouts } from "virtual:generated-layouts"
import { createRouter, createWebHistory } from "vue-router/auto"
import { redirects } from './additional-routes'
import { setupGuards } from './guards'
import { ROUTE_ABILITY_META } from './route-ability-meta'

function recursiveLayouts(route) {
  if (route.children) {
    for (let i = 0; i < route.children.length; i++)
      route.children[i] = recursiveLayouts(route.children[i])

    return route
  }

  return setupLayouts([route])[0]
}

function applyAbilityMeta(route) {
  const meta = ROUTE_ABILITY_META[route.name]
  if (meta) {
    route.meta = { ...route.meta, ...meta }
  }
  if (route.children) {
    route.children.forEach(applyAbilityMeta)
  }
  return route
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, behavior: "smooth", top: 60 }

    return { top: 0 }
  },
  extendRoutes: pages => {
    const routes = [...redirects, ...[...pages].map(route => recursiveLayouts(route))]
    routes.forEach(applyAbilityMeta)
    return routes
  },
})

setupGuards(router)
export { router }
export default function (app) {
  app.use(router)
}
